import React from 'react';
import BackButtonPage from "../../../components/BackButtonPage"

function Partnereink() {
    return (
        <>


    <div className='page-content-container'>
        <img src="/assets/tamogatoink.jpg" className='responsive-img' alt="Támogatóink" />
        <BackButtonPage to="/magunkrol" />
    </div>


        </> 
    );
}

export default Partnereink;
